import { mapState } from "vuex";

export default {
    computed: {
        ...mapState({
            expertMode: state => state.expertMode
        })
    }
};